import { footerColumns, navItems } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t-4 border-primary-500 bg-secondary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-article-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">黑料图文</span>
            </div>
            <p className="mt-4 max-w-sm font-body text-sm leading-relaxed text-foreground-600">
              黑料图文深扒解析栏目，用长图与多图对比拆解事件细节。从聊天记录到公开动态逐层还原，
              帮助读者看清前因后果与幕后关联。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  className="cursor-pointer rounded-full bg-background-50 px-3 py-1 font-label text-xs text-foreground-700 transition-colors hover:text-primary-600"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold tracking-widest text-foreground-950">
                {col.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer font-body text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-secondary-300 pt-6 sm:flex-row sm:items-center">
          <p className="font-label text-xs text-foreground-500">
            © 2026 黑料图文 ｜ 内容以逐层拆解与时间线还原为主
          </p>
          <div className="flex items-center gap-4">
            <span className="font-label text-xs text-foreground-500">长图 · 对比 · 时间线</span>
            <a
              href="#top"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:text-primary-600"
              aria-label="返回顶部"
            >
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}